import { TravelLocalKnowledge } from './TravelLocalKnowledge';

export default TravelLocalKnowledge;
